import algoliarecommend, { RecommendClient } from "@algolia/recommend"

let client: RecommendClient

export const getRecommendClient = () => {
  if (!client) {
    client = algoliarecommend(
      process.env.ALGOLIA_APPLICATION_ID as string,
      process.env.ALGOLIA_SEARCH_API_KEY as string
    )
  }
  return client
}
